import {
  Flex,
  InputGroup,
  NumberInput,
  NumberInputField,
  Text,
} from '@chakra-ui/react';
import Decimal from 'decimal.js';
import React, {forwardRef, useEffect} from 'react';
import { numberFormat } from './Number';

export const TwNumberInput = forwardRef(
  (
    {
      isPercentage,
      onChange,
      onBlur,
      value,
      isDisabled,
      showPrefix,
      w,
      max,
      min,
      step,
      precision,
      readOnly,
      inputProps,
      isCurrency,
      placeholder,
      variant,
      onKeyDown,
      isNothing,
    },
    ref
  ) => {

      const [uid, setUid] = React.useState(Math.random().toString(36).substring(2, 15));

      const [values, setValues] = React.useState({
          strValue: String(value),
          numValue:
            value === null || value === undefined || value === ''
              ? null
              : Number(value),
      });


      useEffect(() => {
      }, [values])

    let patternOnChange = '^-?\\d*(\\.\\d{0,3})?$';
    let pattern = '^-?\\d{1,3}(,\\d{3})*(\\.\\d{1,3})?$';
    if (precision === 0) {
      patternOnChange = '^-?\\d*$';
      pattern = '^-?\\d{1,3}(,\\d{3})*$';
    }

    const format = (_value) => {
      if (_value === '-') {
        return _value;
      }

      // Add handling for string values that are in progress
      if (
        typeof _value === 'string' &&
        (_value.endsWith('0') || _value.endsWith('.'))
      ) {
        return value;
      }

      if (
        isNaN(_value) ||
          _value === null ||
          _value === undefined ||
          _value === ''
      ) {
        return '';
      }

      let newValue = _value;

      if (isPercentage) {
        if (!(typeof _value === 'string' && _value.endsWith('.'))) {
          newValue = _value * 100;
        }
      }

      if (isNothing) {
          if (!(typeof _value === 'string' && _value.endsWith('.'))) {
              newValue = _value * 1;
          }
      }

      newValue = numberFormat(newValue, {
        maximumFractionDigits: isNaN(precision) ? 2 : precision,
      });

      if (typeof _value === 'string' && _value.endsWith('.')) {
        return newValue + '.';
      }

      return newValue;
    };

    const onValueChange = (strValue, numValue) => {
      if (strValue.match(patternOnChange) === null) {
        return;
      }

      let _value = numValue;

      // Add this condition to handle decimal numbers in progress
      if (
        strValue.endsWith('.') ||
        strValue === '-' ||
        strValue.endsWith('.0')
      ) {
          _value = strValue;
      } else if (isPercentage && !strValue.endsWith('.')) {
        numValue = Decimal.div(numValue, 100).toNumber();
        strValue = numValue.toString();
          _value = numValue;
      }

      setValues({ strValue, numValue });
      onChange && onChange(_value);
    };

    const elm = (
      <InputGroup w={w || 'full'}>
        <NumberInput
          isDisabled={isDisabled}
          w={'full'}
          pattern={pattern}
          value={format(value)}
          step={step}
          max={max}
          min={min}
          precision={precision}
          readOnly={readOnly}
          onChange={(strValue, numValue) => {
            onValueChange(strValue, numValue);
          }}
          onBlur={() => {
            onChange && onChange(values.numValue);
            onBlur && onBlur(values.numValue);
          }}
          variant={variant}
          onKeyDown={onKeyDown}
        >
          <NumberInputField
            {...inputProps}
            placeholder={placeholder}
            ref={ref}
          />
        </NumberInput>
      </InputGroup>
    );

    if (showPrefix) {
      return (
        <Flex gap={'5px'} alignItems={'center'} justifyContent={'flex-end'}>
          <Text>{isCurrency ? '$' : isPercentage ? '%' : ''}</Text>
          {elm}
        </Flex>
      );
    }

    return elm;
  }
);

export const CurrencyNumberInput = forwardRef((props, ref) => {
  return (
      <TwNumberInput
        {...props}
        isCurrency={true}
        precision={2}
        ref={ref}
      />
  );
});

export const PercentageNumberInput = forwardRef((props, ref) => {
  return (
    <TwNumberInput
      {...props}
      isPercentage={true}
      precision={props.precision || 3}
      ref={ref}
    />
  );
});

// TODO: remove, for testing purposes only
export const AnotherNumberInput = forwardRef((props, ref) => {
    return (
        <TwNumberInput
            {...props}
            isNothing={true}
            precision={props.precision || 3}
            ref={ref}
        />
    );
});
